<div tiptapDraggable [ngClass]="{ editable: isEditable, selected: isEditable && selected() }">
<dl>
    <dt>Question one</dt>
    <dd>
        <strong>Answer one</strong>
    </dd>
    <dt>Question two</dt>
    <dd>
        <strong>Answer two</strong>
    </dd>
</dl>
</div>
